import * as React from 'react'
import { useMemo } from 'react'
import { Text, Tooltip } from '@fluentui/react-components'
import { MailInbox20Regular, Send20Regular } from '@fluentui/react-icons'
import { BaseTimeSuggestionLineItemProps, useItemStyles } from './BaseTimeSuggestionOverview'
import { useOverviewStyles } from '../BaseOverview/BaseOverview'
import useViewport, { Viewport } from '../../hooks/useViewport'
import FormattedDateTime from '../../components/Date/FormattedDateTime'
import { Link } from 'react-router-dom'
import { TimeFormats } from '../../helpers/dateHelper'

export default function TimeSuggestionListItem(props: BaseTimeSuggestionLineItemProps) {
    const itemStyles = useItemStyles()
    const overviewStyles = useOverviewStyles()
    const { viewport, isViewport } = useViewport()

    const listItemSmall = useMemo<boolean>(() => isViewport('<', Viewport.XL), [viewport])

    if (listItemSmall) {
        return (
            <>
                <div className={overviewStyles.centerItems}>{props.item.emailInbound ? <MailInbox20Regular /> : <Send20Regular />}</div>
                <div>
                    <div className={itemStyles.listInvoiceItemRow1Small}>
                        <Text>{props.item.emailInbound ? props.item?.senderName : props.item?.recipientsName || ''}</Text>
                    </div>
                    <div className={itemStyles.listInvoiceItemRow2Small}>
                        <Text>{props.item.subject || ''}</Text>
                    </div>
                    <div className={itemStyles.listInvoiceItemRow3Small}>
                        <FormattedDateTime date={props.item.emailSent} format={TimeFormats.ISO} />
                        <div></div>
                        {!props.hideFileField ? (
                            <Tooltip relationship={'label'} content={props.item.file.name} withArrow>
                                <Link key={props.item.id} to={`/file/${props.item.file.id}`}>
                                    <Text size={200}>{props.item.file.reference}</Text>
                                </Link>
                            </Tooltip>
                        ) : (
                            <div></div>
                        )}
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <div className={overviewStyles.centerItems}>{props.item.emailInbound ? <MailInbox20Regular /> : <Send20Regular />}</div>
            <div>
                <div className={itemStyles.listInvoiceItemRow1}>
                    <Text>{props.item.emailInbound ? props.item?.senderName : props.item?.recipientsName || ''}</Text>
                    <FormattedDateTime date={props.item.emailSent} format={TimeFormats.ISO} />
                </div>
                <div className={itemStyles.listInvoiceItemRow2}>
                    <Text>{props.item.subject || ''}</Text>
                    {!props.hideFileField ? (
                        <Tooltip relationship={'label'} content={props.item.file.name} withArrow>
                            <Link key={props.item.id} to={`/file/${props.item.file.id}`}>
                                <Text size={200}>{props.item.file.reference}</Text>
                            </Link>
                        </Tooltip>
                    ) : (
                        <div></div>
                    )}
                </div>
            </div>
        </>
    )
}
